import './leftMenuItem.scss';
import SvgIcon from 'components/commons/icons/SvgIcon';

 export default function LeftMenuItem ({ icon, text, onClick }) {
    return (
        <div className='left-menu-item' onClick={()=>onClick && onClick()}>
            <SvgIcon
            ariaLabel={text}
            Icon={icon}
            className='left-menu-item-img'
            />
            <span className='left-menu-item-text'>{text}</span>
        </div>
    );
 }
